import React, { useState } from 'react';
import axios from 'axios';
import { Table, Button, Row, Col } from 'react-bootstrap';
import ManageProduct from './ManageProduct';
import { PRODUCT_CREATE_RESET } from '../constants/productConst';
import { REGISTER_EVENT_LIST_SUCCESS } from '../constants/resgistertEventConst';
import copy from 'copy-to-clipboard';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SearchProduct = ({ isAdmin = false, keyword = '' }) => {
  // Your component logic here
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [pageSettingData, setPageSettingData] = useState([]);
  const [products, setProducts] = useState([]);
  const createdDate = new Date().toISOString();
  const [fname, setFname] = useState(true);
  const [lname, setLnam] = useState(true);

  const handleSearch = async (e) => {
    e.preventDefault();

    if(window.Shopline.customer === undefined){
      toast("Please login before to access registry.!");
      return false;
    }

    if(window.Shopline.customer !== undefined){
        const userData = {
          r_fname: firstName,
          r_lname: lastName,
          customer_id: `${window.Shopline.customer.id}`,
          handle: `${window.Shopline.handle}`,
        };

        axios.post("https://wiser-ai.expertvillagemedia.com/api/searchregistry", userData)
        .then((response) => {
          //console.log(response);
          setProducts(response.data.data);
        })
        .catch((error) => {
          if (error.response) {
            //console.log(error.response);
            //console.log("server responded");
          } else if (error.request) {
            //console.log("network error");
          } else {
            //console.log(error);
          }
        });
    }  
  };

  const shareProduct = (productId) => {
    // Generate the shareable link based on your app's URL structure
    const shareableLink = `https://${window.Shopline.handle}.myshopline.com/pages/evmnew/?evm_shared_giftregistry=${productId}`;    
    // Copy the link to the clipboard
    copy(shareableLink);    
    // You can also provide feedback to the user that the link has been copied    
    toast('Giftregistry link copied to clipboard!');
  };

  const formatDate = (datestr) => {
    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(datestr).toDateString([], options);
  };
  return (
    <div className="container_1054">
      <div className="form-horizontal find_registry_wrapper">
        <div className="custom-registry-content">
          <h4>
            Find A Gift Registry
          </h4>
          <label>Enter a first or last name below to quickly locate a registry.</label>
        </div>
        <div className="aaagift-find-form custom-registry-form">
          <div className="one-third-width one-third-width-left mar-bot-10">
            <div className="full-width">
              <input
                type="text"
                placeholder="First Name"
                name="registrant_f_name"
                id="registrant_f_name"
                className="form-control aaa-validate"
                value={firstName}
                onChange={e => setFirstName(e.target.value)}
              />
            </div>
            {fname === false && <div className="error">Please enter Registrant first name.</div>}
          </div>
          <div className="one-third-width-middle one-third-width mar-bot-10">
            <div className="full-width">
              <input
                type="text"
                placeholder="Last Name"
                name="registrant_l_name"
                id="registrant_l_name"
                className="form-control aaa-validate"
                value={lastName}
                onChange={e => setLastName(e.target.value)}
              />
            </div>
            {lname === false && <div className="error">Please enter Registrant last name.</div>}

          </div>
          <div className="aaagift-find-form custom-registry-button one-third-width-right one-third-width mar-bot-10">
            <div className="form-horizontal">
              <div className="full-width">
                <center>
                  <button className="btn btn-primary aaa_find_registry" style={{ textTransform: 'capitalize', backgroundColor: '#5c90d2' }} onClick={handleSearch}>Find</button>
                </center>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='evm-search-list-wrapper'>
        <table className="table table-bordered searchlist_responsive table_custom">
          <thead className="sm_d_none">
            <tr>
              <th style={{ width: 'auto' }}>S.No</th>
              <th style={{ width: 'auto' }}>Title</th>
              <th style={{ width: 'auto' }}>Event Id</th>
              <th style={{ width: 'auto' }}>Event Name</th>
              <th style={{ width: '15%' }} className="">Event Date</th>
              <th style={{ width: '15%' }} className="">Create Date</th>
              <th style={{ width: '15%' }} className="">Owner</th>
              {/*
                <th style={{ width: 'auto' }} className="ifcustomer">
                  View
                </th>
                */}
              <th style={{ width: 'auto' }} className="ifcustomer">
                Share
              </th>
            </tr>
          </thead>
          <tbody>
            {products.length > 0 ? (
              products.map((product, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{product.regtitle}</td>
                  <td>{product.id}</td>
                  <td>{product.regtype}</td>
                  <td>{formatDate(`${product.regdate}`)}</td>
                  <td>{formatDate(`${product.created_at}`)}</td>
                  <td>{product.r_fname}{' '}{product.l_fname}</td>
                  {/*<td> <a href={`./user-event/${product.id}`}>view</a></td>*/}
                  <td><Button variant='primary' className='btn-sm' onClick={() => shareProduct(product.id)}> Share </Button></td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8">No products found.</td>
              </tr>
            )}
          </tbody>
          <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
              />
        </table>
      </div>
    </div>
  );
};
export default SearchProduct;